import React, { useMemo, useState } from 'react';
import { getData,postData } from '../../../global/Globalapi';

const Input = ({ label, value, onChange, placeholder }) => (
  <div className="mb-4">
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <input
      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
    />
  </div>
);

const Select = ({ label, value, onChange, options, placeholder }) => (
  <div className="mb-4">
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <select
      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
      value={value}
      onChange={e => onChange(e.target.value)}
    >
      <option value="">{placeholder || 'All'}</option>
      {options.map(opt => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  </div>
);

export default function SMSBroadcast() {
  const [message, setMessage] = useState('Hello! This is a test SMS.');
  const [userstatus, setUserstatus] = useState('');
  const [usertype, setUsertype] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const [phoneList, setPhoneList] = useState('');
  const [showPhoneList, setShowPhoneList] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const preview = useMemo(() => message, [message]);

  // Fetch filtered phone numbers from backend
  const getFilteredPhones = async () => {
    try {
      const payload = { filter: {} };
      if (userstatus) payload.filter.userstatus = userstatus.toLowerCase();
      if (usertype) payload.filter.usertype = usertype.toLowerCase();

      const { data } = await getData('/sms/test', payload);

      // Filter users based on selected filters
      const filtered = data.data.filter(user => {
        const statusMatch = userstatus
          ? (user.userstatus || '').toLowerCase() === userstatus.toLowerCase()
          : true;
        const typeMatch = usertype
          ? (user.usertype || '-').toLowerCase() === usertype.toLowerCase()
          : true;
        return statusMatch && typeMatch && user.mobile && user.mobile.trim().length >= 10;
      });

      setFilteredUsers(filtered);
      const phones = filtered.map(u => u.mobile.trim());
      return phones;
    } catch (err) {
      console.error('Error fetching phone numbers:', err);
      return [];
    }
  };

  // Send SMS function
  // const sendSMS = async () => {
  //   if (!message) {
  //     alert('Please provide a message');
  //     return;
  //   }

  //   setSending(true);
  //   setResult(null);

  //   try {
  //     const phones = await getFilteredPhones();

  //     if (!phones.length) {
  //       setResult({ success: false, message: 'No recipients found with the selected filters' });
  //       return;
  //     }

  //     let sentCount = 0;
  //     let failedCount = 0;

  //     for (const phone of phones) {
  //       try {
  //         await postData('/send-broadcast/sms', { to: phone, message });
  //         sentCount++;
  //       } catch (error) {
  //         console.error(`Failed to send SMS to ${phone}:`, error);
  //         failedCount++;
  //       }
  //     }

  //     setResult({
  //       success: true,
  //       message: `SMS broadcast completed`,
  //       totals: {
  //         recipients: phones.length,
  //         sent: sentCount,
  //         failed: failedCount
  //       }
  //     });
  //   } catch (err) {
  //     setResult({ success: false, message: err.message });
  //   } finally {
  //     setSending(false);
  //   }
  // };
const sendSMS = async () => {
  if (!message) {
    alert("Please provide a message");
    return;
  }

  setSending(true);
  setResult(null);

  try {
    const phones = await getFilteredPhones(); // returns array of numbers

    if (!phones.length) {
      setResult({
        success: false,
        message: "No recipients found with the selected filters",
      });
      return;
    }

    // POST all numbers in one request
    const payload = {
      message,
      numbers: phones,
    };

    const response = await postData('/send-broadcast/sms', payload);
console.log("SMS send response:", response);
    setResult({
      success: true,
      message: response.message || "SMS broadcast completed",
      totals: response.totals,
      sent: response.sent,
      failed: response.failed,
    });
  } catch (err) {
    console.error("SMS send error:", err);
    setResult({
      success: false,
      message: err.response?.data?.message || err.message || "SMS sending failed",
    });
  } finally {
    setSending(false);
  }
};

  const previewPhones = async () => {
    setSending(true);
    setResult(null);
    try {
      const phones = await getFilteredPhones();
      if (!phones.length) {
        setResult({ success: false, message: 'No recipients found with the selected filters.' });
        setPhoneList("No recipients found with the selected filters.")
      } else {
        setPhoneList(phones.join(', '));
        setShowPhoneList(true);
        setResult({ success: true, message: `Found ${phones.length} recipients` });
      }
    } catch (err) {
      setResult({ success: false, message: 'Failed to fetch phone numbers: ' + err.message });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="w-full max-w-6xl mx-auto p-4 md:p-6">
      <h1 className="text-2xl md:text-3xl font-semibold mb-4">SMS Broadcast</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        <div className="lg:col-span-2">
          <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 md:p-5">
            <div className="mb-3 md:mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
              <textarea
                className="w-full h-52 md:h-56 border border-gray-300 rounded px-3 py-2 font-mono text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                value={message}
                onChange={e => setMessage(e.target.value)}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
              <Select label="User Status" value={userstatus} onChange={setUserstatus} options={["active","inactive"]} placeholder="All statuses" />
              <Select label="User Type" value={usertype} onChange={setUsertype} options={["Admin","staff","guest"]} placeholder="All types" />
            </div>

            {showPhoneList && (
              <div className="mb-3 md:mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Filtered Phone List ({phoneList.split(',').length} recipients)
                </label>
                <textarea
                  className="w-full h-24 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  value={phoneList}
                  onChange={e => setPhoneList(e.target.value)}
                  placeholder="Phone numbers will be populated based on filters"
                />
              </div>
            )}

            <div className="mt-3 md:mt-4 flex gap-3 flex-wrap">
              <button
                onClick={previewPhones}
                disabled={sending}
                className="px-4 py-2 rounded border border-blue-300 text-white-700 hover:bg-blue-500 disabled:opacity-50"
              >
                {sending ? 'Loading...' : 'Preview Recipients'}
              </button>

              <button
                onClick={sendSMS}
                disabled={sending || !showPhoneList}
                className={`px-5 py-2 rounded text-white ${sending || !showPhoneList ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'} transition`}
              >
                {sending ? 'Sending...' : 'Send SMS Broadcast'}
              </button>

              <button
                onClick={() => {
                  setMessage('Hello! This is a test SMS.');
                  setPhoneList('');
                  setShowPhoneList(false);
                  setUserstatus('');
                  setUsertype('');
                  setResult(null);
                }}
                disabled={sending}
                className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-500"
              >
                Reset All
              </button>
            </div>

            {result && (
              <div className={`mt-3 md:mt-4 p-3 rounded ${result.success ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
                <div className="font-semibold">{result.message || (result.success ? 'Broadcast sent' : 'Failed')}</div>
                {result.totals && (
                  <div className="text-sm mt-1">
                    Recipients: {result.totals.recipients}, Sent: {result.totals.sent}, Failed: {result.totals.failed}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 md:p-5">
            <h2 className="text-xl font-semibold mb-2">Live Preview</h2>
            <div className="border rounded p-3 bg-gray-50 overflow-auto max-h-[520px]">
              <p>{preview}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
